// src/menu.js
// 后台菜单/权限目录。key 与后端 server/constants/menuCatalog.js 保持一致。
// 前端动态菜单渲染、权限勾选、路由守卫都依赖这份数据。
export const SUPER_ROLE = 'super_admin'

export const MENU_CATALOG = [
  { key: 'dashboard', title: '仪表盘', icon: 'el-icon-s-home', path: '/dashboard', alwaysShow: true },
  { key: 'activities', title: '课程管理', icon: 'el-icon-document', path: '/activities' },
  { key: 'timetable', title: '课程表', icon: 'el-icon-date', path: '/timetable' },
  { key: 'course-categories', title: '课程分类', icon: 'el-icon-menu', path: '/course-categories' },
  { key: 'schools', title: '学校资料', icon: 'el-icon-office-building', path: '/schools' },
  { key: 'mentors', title: '导师资料', icon: 'el-icon-s-custom', path: '/mentors' },
  { key: 'registrations', title: '报名管理', icon: 'el-icon-tickets', path: '/registrations' },
  { key: 'orders', title: '订单管理', icon: 'el-icon-money', path: '/orders' },
  { key: 'news', title: '新闻公告', icon: 'el-icon-reading', path: '/news' },
  { key: 'users', title: '用户管理', icon: 'el-icon-user', path: '/users' },
  { key: 'help-config', title: '帮助与联系', icon: 'el-icon-chat-dot-round', path: '/help-config' },
  { key: 'agreement-config', title: '协议配置', icon: 'el-icon-document-checked', path: '/agreement-config' },
  { key: 'admin-management', title: '管理员管理', icon: 'el-icon-setting', path: '/admins', superOnly: true }
]

const SEGMENT_TO_KEY = {
  dashboard: 'dashboard',
  activities: 'activities',
  timetable: 'timetable',
  'course-categories': 'course-categories',
  schools: 'schools',
  mentors: 'mentors',
  registrations: 'registrations',
  orders: 'orders',
  news: 'news',
  users: 'users',
  'help-config': 'help-config',
  'agreement-config': 'agreement-config',
  admins: 'admin-management'
}

// 由路由 path 推导其所需的权限 key（用于路由守卫拦截）。
export function permissionForPath(path) {
  if (!path) return null
  const segment = path.split('/').filter(Boolean)[0]
  return SEGMENT_TO_KEY[segment] || null
}

// 可分配给普通管理员的菜单（仪表盘常驻、管理员管理仅超管可见，都不在下发范围内）
export function assignableMenus() {
  return MENU_CATALOG.filter(m => m.key !== 'dashboard' && m.key !== 'admin-management')
}
